import * as React from "react";
import { setTitle } from "utils";

export function NotFoundPage() {
  setTitle("404");
  return <div>404</div>;
}
